import React from "react";
import { reportError } from "./errorReporting";
import kickrKMark from "./assets/kickr_k_mark_cropped.png";

/**
 * Top-level error boundary. Catches any unhandled render error and shows a
 * friendly fallback instead of a white screen. Reports the error to whatever
 * tracker is configured in errorReporting.js (Sentry once wired up).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    reportError(error, { componentStack: info?.componentStack });
  }

  handleReload = () => {
    // Hard reload — clears in-memory state but keeps localStorage so the user
    // stays signed in.
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        fontFamily: "system-ui, -apple-system, sans-serif",
        background: "#f6faf7",
        color: "#0d1526",
        textAlign: "center",
        gap: 16,
      }}>
        <img src={kickrKMark} alt="" style={{ width: 48, height: 48, objectFit: "contain" }} />
        <div style={{ fontSize: 22, fontWeight: 700 }}>Something went wrong</div>
        <div style={{ fontSize: 14, color: "#4b5563", maxWidth: 320 }}>
          The app hit an unexpected error. We've logged it. Try reloading — your
          account and saved games are safe.
        </div>
        <button
          onClick={this.handleReload}
          style={{
            background: "#22c55e",
            color: "#ffffff",
            border: "none",
            borderRadius: 8,
            padding: "12px 24px",
            fontSize: 15,
            fontWeight: 600,
            cursor: "pointer",
            minHeight: 44,
          }}
        >
          Reload kickr
        </button>
        {import.meta.env.DEV && this.state.error && (
          <pre style={{
            marginTop: 16,
            fontSize: 11,
            color: "#7f1d1d",
            background: "#fef2f2",
            padding: 12,
            borderRadius: 6,
            maxWidth: "90vw",
            overflow: "auto",
            textAlign: "left",
          }}>
            {String(this.state.error?.stack || this.state.error)}
          </pre>
        )}
      </div>
    );
  }
}
